import { render, staticRenderFns } from "./ProjetoWindow.vue?vue&type=template&id=10039fe2"
import script from "./ProjetoWindow.vue?vue&type=script&lang=js"
export * from "./ProjetoWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports